module.exports = "./../img/ajax-loader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/ajax-loader.gif
// module id = 76
// module chunks = 0